import { defineStore } from "pinia";
import type { DRDrawing, DRPartialProject } from "@/types";
import { computed, ref, watch } from "vue";
import { liveQuery } from "dexie";
import { projectRepository } from "@/repositories/project.repository";
import UserState from "./UserState";

export const useProjectsStore = defineStore("projectsStore", () => {
  const organizationId = computed(() => UserState.data?.organization?.id);

  const localProjects = ref<DRPartialProject[]>([]);

  const localDataObservable = liveQuery<DRPartialProject[]>(() =>
    projectRepository.getMany({})
  );

  localDataObservable.subscribe({
    next: (result: DRPartialProject[]) => {
      localProjects.value = result;
    },
  });

  watch(
    organizationId,
    async () => {
      if (organizationId.value) {
        projectRepository.setCurrentOrganizationId(organizationId.value);
        localProjects.value = await projectRepository.getMany({});
      }
    },
    {
      immediate: true,
    }
  );

  const getDrawingsWithProject = (
    drawings: DRDrawing[]
  ): (DRDrawing & { project?: DRPartialProject })[] => {
    return drawings.map((drawing) => {
      const project = localProjects.value.find(
        (proj) => proj.id === drawing.projectId
      );
      return {
        ...drawing,
        project: project,
      };
    });
  };

  return {
    // data
    localProjects,
    getDrawingsWithProject,
  };
});
